import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactUsService } from './contactus.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ErrorMessages } from '../../../shared/common/ErrorMessages';
import { SuccessMessages }  from '../../../shared/common/SuccessMessages';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  contactUsForm: FormGroup | undefined;
  submitted = false;
  private onDestroy$: Subject<void>=new Subject<void>();
  successMessage: string;
  errorMessage: string;

  constructor(private fb: FormBuilder,
    private _contactUsService: ContactUsService
    ) { 
    
  }

  ngOnInit(): void {
    this.createForm();
  }

  get registerFormControl() {
    return this.contactUsForm.controls;
  }

  createForm() {
    this.contactUsForm = this.fb.group({
      name: ['',[Validators.required, Validators.maxLength(50)]],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', [Validators.required, Validators.maxLength(200)]],
      message: ['', [Validators.required, Validators.maxLength(1000)]],
    });
  }

  onSubmit(form: FormGroup) {
    if (!this.contactUsForm.valid) {
      return;
    }

    this._contactUsService.addContactUs(this.contactUsForm.value).pipe(takeUntil(this.onDestroy$))
    .subscribe((response: any) => {
console.log(response.Data);
debugger
      if (response !== null  && response.data !== null && response.statusCode === 200) {                  
          this.successMessage = response.data.message;
      } else if (response == null && response.StatusCode === 204) {
        this.errorMessage = response.data.message;
      } else {        
        this.errorMessage = response.data.message;

        console.log('errorMessage-' + this.errorMessage);
      }
    });  
    
    this.contactUsForm.reset();
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

}
